"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSpecificHours_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TimeZone_1 = require("./TimeZone");
var UserDailyWorkingHours_1 = require("./UserDailyWorkingHours");
var User_1 = require("./User");
var UserSpecificHours_Factory = /** @class */ (function () {
    function UserSpecificHours_Factory() {
    }
    UserSpecificHours_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TimeZone: TimeZone_1.TimeZone_Factory.CreateIncoming(model.TimeZone),
            TimeZoneId: model.TimeZoneId,
            UserDailyWorkingHours: model.UserDailyWorkingHours && model.UserDailyWorkingHours.map(function (i) { return UserDailyWorkingHours_1.UserDailyWorkingHours_Factory.CreateIncoming(i); }),
            UserId: model.UserId,
            Users: User_1.User_Factory.CreateIncoming(model.Users),
        };
        return result;
    };
    UserSpecificHours_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TimeZone: TimeZone_1.TimeZone_Factory.CreateOutgoing(model.TimeZone),
            TimeZoneId: model.TimeZoneId,
            UserDailyWorkingHours: model.UserDailyWorkingHours && model.UserDailyWorkingHours.map(function (i) { return UserDailyWorkingHours_1.UserDailyWorkingHours_Factory.CreateOutgoing(i); }),
            UserId: model.UserId,
            Users: User_1.User_Factory.CreateOutgoing(model.Users),
        };
        return result;
    };
    return UserSpecificHours_Factory;
}());
exports.UserSpecificHours_Factory = UserSpecificHours_Factory;
